export const portainerKeys = {
  all: ['portainer'],
  groups: () => [...portainerKeys.all, 'groups'],
};
